import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Link} from 'react-router-dom'
import {Button, Switch} from 'antd'

import style from './header.sass'

@inject('store') @observer
class Header extends Component {
  pause = () => this.props.store.paperTrading.pause()
  unpause = () => this.props.store.paperTrading.unpause()
  stop = async () => {
    await this.props.store.paperTrading.stop()
    window.location.reload()
  }
  toggleNotifications = () => {
    const {paperTrading} = this.props.store
    const {is_notification_on} = paperTrading.session
    if (is_notification_on) {
      paperTrading.turnNotificationsOff()
    } else {
      paperTrading.turnNotificationsOn()
    }
  }

  render() {
    const {session, algo, loadingStatuses} = this.props.store.paperTrading
    return(
      <div styleName='wrapper'>
        <div>
          {algo.name && [
            <Link key='link' styleName='algo-link' to={`/builder/edit/${algo.id}`}>{algo.name}</Link>,
            <span key='separator' styleName='separator'>/</span>
          ]}
          <h4 styleName='title'>{this.props.title}</h4>
        </div>
        <div>
          {!session.end_date &&
            <span>
              Notifications
              <Switch
                checked={session.is_notification_on}
                onClick={this.toggleNotifications}
                loading={loadingStatuses.is_notification_on}
                styleName='switch'
              />
            </span>
          }
          {algo?.backtest?.id &&
            <Button>
              <Link to={'/backtest/algo/' + algo.backtest.id}>Backtest results</Link>
            </Button>
          }
          {!session.end_date &&
            <div>
              <Button
                type='primary'
                onClick={session.is_paused ? this.unpause : this.pause}
                loading={loadingStatuses.is_paused}
              >
                {session.is_paused ? 'Resume' : 'Pause'}
              </Button>
              <Button
                type='danger'
                onClick={this.stop}
                loading={loadingStatuses.is_active}
              >
                Close all
              </Button>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default Header
